var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-row"},[_c('label',[_vm._v(_vm._s(_vm.label))]),_c('div',{staticClass:"form-ctrls"},[_vm._t("default")],2),_c('div',{staticClass:"form-help"},[_vm._v(_vm._s(_vm.description))])])
}
var staticRenderFns = []

export { render, staticRenderFns }